"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerBustForkRule = void 0;
const logic_types_1 = require("../logic-types");
const game_rule_1 = require("./game-rule");
class PlayerBustForkRule extends game_rule_1.AbstractGameRule {
    constructor(playerId, hasBustRules, continueRules) {
        super();
        this.playerId = playerId;
        this.hasBustRules = hasBustRules;
        this.continueRules = continueRules;
    }
    applyRule(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const player = context.playerManager.playerFromId(this.playerId);
            if (player.isBust) {
                context.gameState.sendHandResult(player, logic_types_1.RoundResult.PlayerBust, instant);
                return yield this.hasBustRules.execute(commandHash, existingDeal, instant, context);
            }
            return yield this.continueRules.execute(commandHash, existingDeal, instant, context);
        });
    }
}
exports.PlayerBustForkRule = PlayerBustForkRule;
